import {
  CREATE_CAMPAIGN
} from './actionTypes';


import { getActionStatusName } from '@/store/helpers';

export const createCampaignStatus = (state) => state.status[getActionStatusName(CREATE_CAMPAIGN)] || {};